'use strict';

var $ = require('jquery');
var basePage = require('../pages/base-page.js');
var contactDealerButtonByPhone = require('../components/contact-dealer-button.js');
var history = require('../ui/history.js');
var layout = require('../ui/layout.js');
var scrolling = require('../ui/scroll.js');
var tooltip = require('../components/tooltip.js');
var resultsFilterButton = require('../components/results-filter-button.js');
var rppDropdown = require('../components/rpp-dropdown.js');
var sortDropdown = require('../components/sort-dropdown.js');

function setLoadingPanel() {
	var $loadingPanel = $.findByBem('results-loading-panel');
	var $results = $.findByBem('search-results');
	if ($loadingPanel.length === 0) {
		$results.before('<div class="results-loading-panel"><div class="results-loading-panel__spinner"></div>Updating results, please wait</div>');
	}

	$results.addBemClass('vfs-search-results', 'container','loading');
}

function setOffCanvasCallback() {
	$(document).on('open.fndtn.offcanvas', '[data-offcanvas]', function() {
		basePage.advert.hideGumGum();
		$('body').scrollTop(0);
	});

	$(document).on('close.fndtn.offcanvas', '[data-offcanvas]', function() {
		var $form = $.findByBem('vfs-search-filters');
		var url = $form.attr('action');
		var data = $form.attr('data-update');

		basePage.advert.showGumGum();

		if (layout.isMobile()) {			
			if (data === 'true') {
				setLoadingPanel();

				var anchorUrl = url + '#filterActions';
				window.location = anchorUrl;

				if (window.location.pathname === url) {
					window.location.reload(true);
				}
			}

			scrolling.scrollTo($('#filterActions'), 10);
		}
	});
}

function setSelectedFacetsRemoveLinks() {
	$.findByBem('selected-facets').on('click.vfsResults', function() {
		setLoadingPanel();
	});
}

basePage.init = function() {
	basePage.initBasePage();

	rppDropdown.init();
	sortDropdown.init();
 
	setOffCanvasCallback();
	setSelectedFacetsRemoveLinks();

	var $context = $('#vfsSearchResults');
	
	resultsFilterButton.init();
	tooltip.init($context);

	contactDealerButtonByPhone.init();

	history.setState({ vfsSearch: true });

	history.onStateChange(function(state) {
		if (state && state.vfsSearch) {
			window.location.reload();
		}
	});
	
};

module.exports = basePage;